import { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Start from '../public/Start/Start';
import { Home } from '../private/Home/Home';
import { Crm } from '../private/Crm/Crm';
import LeadsForm2 from '../public/leads/leadsForm2';
import ErrorBoundaryClass from '../components/ErrorBoundary/ErrorBoundary';
import { Box, CircularProgress, Typography } from '@mui/material';
import MetaCallback from '../services/metaCallBack';

const SingUp = lazy(() => import('../public/Login/SingUp'));
const Login = lazy(() => import('../public/Login/Login'));
const Forget = lazy(() => import('../public/Login/Forget'));
const Leads = lazy(() => import('../public/leads/leads'));

// Componente de Loading personalizado para usar com Suspense
const LoadingFallback = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      bgcolor: '#f5f5f5'
    }}
  >
    <CircularProgress size={60} thickness={4} />
    <Typography variant="h6" sx={{ mt: 2 }}>Carregando...</Typography>
  </Box>
);

function AppRoutes() {
  const ProtectedRoute = ({ redirectPath = '/', children }) => {
    const token = JSON.parse(localStorage.getItem('token'));
    const { state } = useLocation();
    if (!token || token === 'token global' || token === undefined
      || !state?.account || state?.account === undefined) {
      return <Navigate to={redirectPath} replace />;
    }
    return <>{children}</>;
  };

  return (
    <ErrorBoundaryClass>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/start" element={<Start />} />
          <Route path="/singin" element={<Login />} />
          <Route path="/singup" element={<SingUp />} />
          <Route path="/forget" element={<Forget />} />
          <Route path="/meta-callback" element={<MetaCallback />} />
          <Route path="/leads/:id1/:id2/:id3/:id4/:id5" element={
            <ErrorBoundaryClass>
              <Leads />
            </ErrorBoundaryClass>
          } />
          <Route path="/leads2/:id1/:id2/:id3/:id4/:id5" element={
            <ErrorBoundaryClass>
              <LeadsForm2 onSubmit={(data) => {               
                return Promise.resolve(data); // Simula uma promessa bem-sucedida
              }} />
            </ErrorBoundaryClass>
          } />

          <Route path="home/" element={
            <ProtectedRoute redirectPath="/singin">
              <ErrorBoundaryClass>
                <Home />
              </ErrorBoundaryClass>
            </ProtectedRoute>
          } />
          <Route path="crm/" element={
            <ProtectedRoute redirectPath="/singin">
              <ErrorBoundaryClass>
                <Crm />
              </ErrorBoundaryClass>
            </ProtectedRoute>
          } />
          
          {/* Rota curinga para capturar todas as rotas não definidas */}
          <Route path="*" element={
            <ErrorBoundaryClass>
              <Navigate to="/start" replace />
            </ErrorBoundaryClass>
          } />
        </Routes>
      </Suspense>
    </ErrorBoundaryClass>
  );
}

export default AppRoutes;